import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * Fetch a content block by key from the backend. Falls back to provided
 * mock value if the API errors out or returns an empty array.
 */
export default function useContent(key, fallback) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    api.getContent(key)
      .then((res) => {
        if (cancel) return;
        const val = res && res.data;
        if (Array.isArray(val) && val.length > 0) setData(val);
        else if (val && !Array.isArray(val)) setData(val);
        else setData(fallback);
      })
      .catch((err) => {
        if (cancel) return;
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`useContent('${key}') falling back to default`, err);
        }
        setData(fallback);
      })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  // We intentionally don't include `fallback` in deps because it's a default
  // value provided once by the caller; re-running the effect when callers
  // pass an inline literal would refetch on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { data, loading };
}
